import styled from 'styled-components';
import { customMedia } from 'styles/utils';

import { DefaultWrapper } from 'styles/default';

export const BrandsMainWrapper = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
  text-align: center;
  width: 100vw;
  height: auto;
  padding: 6rem ${props => props.theme.spacing.large};
  background-color: ${props => props.theme.color.wfGrey100};
`;

export const BrandsListWrapper = styled.div`
  margin: 1rem 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-content: center;
  align-items: center;
  width: 100%;
  height: ${props => (props.size === 'small' ? 'auto' : '100%')};
  max-width: ${props => props.theme.layout.maxWidth};
  ${customMedia.lessThan('medium')`
     flex-direction: column;
  `};
`;

export const BrandWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  align-items: center;
  width: ${props => (props.size === 'small' ? '5rem' : 'auto')};
  // height: ${props => (props.size === 'small' ? '2rem' : 'auto')};
  min-width: ${props => (props.size === 'small' ? '5rem' : '13rem')};
  min-height: ${props => (props.size === 'small' ? '2rem' : '13rem')};
  margin: ${props => props.theme.space[4]};

  img {
    transform: scale(${props => (props.size === 'small' ? '0.7' : '1')});
  }

  // ${customMedia.lessThan('medium')`
  //   width: ${props => (props.size === 'small' ? '1rem' : 'auto')};
  //   height: ${props => (props.size === 'small' ? '1rem' : 'auto')};
  //   min-height: ${props => (props.size === 'small' ? '1rem' : '10rem')};
  //   img {
  //     transform: scale(${props => (props.size === 'small' ? '0.5' : '0.7')});
  //   }
  // `};
`;

export const TitleWrapper = styled(DefaultWrapper)`
  h2 {
    color: ${props => props.theme.color.wfGrey600};
  }
`;
